var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChartIcon = function SvgChartIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Chart Icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chart-Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(14.000000, 16.000000)",
    stroke: "#263238",
    strokeWidth: 1.88235294
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9411765,25.4115765 C32.9411765,26.4478118 32.0941176,27.2939294 31.0588235,27.2939294 L27.2941176,27.2939294 C26.2588235,27.2939294 25.4117647,26.4478118 25.4117647,25.4115765 L25.4117647,1.88216471 C25.4117647,0.846870588 26.2588235,-0.000188235294 27.2941176,-0.000188235294 L31.0588235,-0.000188235294 C32.0941176,-0.000188235294 32.9411765,0.846870588 32.9411765,1.88216471 L32.9411765,25.4115765 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6470588,25.4115765 C21.6470588,26.4478118 20.8,27.2939294 19.7647059,27.2939294 L16,27.2939294 C14.9647059,27.2939294 14.1176471,26.4478118 14.1176471,25.4115765 L14.1176471,10.2219294 C14.1176471,9.18663529 14.9647059,8.33957647 16,8.33957647 L19.7647059,8.33957647 C20.8,8.33957647 21.6470588,9.18663529 21.6470588,10.2219294 L21.6470588,25.4115765 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3529412,25.4115765 C10.3529412,26.4478118 9.50588235,27.2939294 8.47058824,27.2939294 L4.70588235,27.2939294 C3.67058824,27.2939294 2.82352941,26.4478118 2.82352941,25.4115765 L2.82352941,18.9541647 C2.82352941,17.9188706 3.67058824,17.0718118 4.70588235,17.0718118 L8.47058824,17.0718118 C9.50588235,17.0718118 10.3529412,17.9188706 10.3529412,18.9541647 L10.3529412,25.4115765 Z",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.67940972e-14,
    y1: 31.0504471,
    x2: 35.7647059,
    y2: 31.0504471,
    id: "Stroke-7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChartIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart-icon.46cdc203.svg";
export { ForwardRef as ReactComponent };